export const shareMessageTitle =
  "Would you like to include a message with your invite?";
export const shareMessageSubtitle =
  "The message will appear at the top of the invite email or text message that is sent to the people you have selected.";
